import { render, staticRenderFns } from "./HelpsList.vue?vue&type=template&id=bce4834a"
import script from "./HelpsList.vue?vue&type=script&lang=js"
export * from "./HelpsList.vue?vue&type=script&lang=js"
import style0 from "./HelpsList.vue?vue&type=style&index=0&id=bce4834a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports